import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import bank4 from "./Assets/bank4.png.jpeg";
import bus2 from "./Assets/bus2.png.jpeg";
import bus3 from "./Assets/bus3.png.jpeg";
import hotel2 from "./Assets/hotel2.png.jpeg";
import hotel4 from "./Assets/hotel4.png.jpeg";
import hotel6 from "./Assets/hotel6.png.jpeg";
const styles=`
@media(max-width:400px){
 .carousel-image{
  max-height: calc(100vh-50px);
 }
}

@media(max-width:600px){
 .carousel-image{
  max-height: calc(100vh-60px);
 }
}
 @media(max-width:900px){
 .carousel-image{
  max-height: calc(100vh-70px);
 }
}

@media(max-width:1200px){
 .carousel-image{
  max-height: calc(100vh-80px);
 }
}

`
const styleSheet=document.createElement("style")
styleSheet.type="text/css"
styleSheet.innerText=styles;
document.head.appendChild(styleSheet)
export default function CustomerDashLP() {
  const images = [bank4, bus2, bus3, hotel2, hotel4, hotel6];
  return (
    <div className="flex flex-col h-[calc(100vh-80px)] w-full overflow-hidden carousel-image">
      <Carousel
        showThumbs={false}
        autoPlay
        infiniteLoop
        className="flex-grow max-h-full"
      >
        {images.map((imageDir, index) => (
          <div key={index} className="flex justify-center items-center w-full h-full overflow-hidden">
            <img
              src={imageDir}
              alt={`Slide ${index}`}
              className="object-cover w-full h-full max-h-[calc(100vh-80px)]"
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}

